/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit-block': {
    width: 200,
    height: 200,
    viewBox: '0 0 1025 1024',
    data: '<path pid="0" d="M953.794 70.231c-10.974-10.976-28.767-10.974-39.742 0L293.597 690.704c-10.974 10.974-10.974 28.767.001 39.742 5.487 5.487 12.679 8.23 19.871 8.23s14.385-2.744 19.871-8.231l620.455-620.473c10.974-10.973 10.974-28.767 0-39.741zm-76.857 272.047c-15.52 0-28.102 12.582-28.102 28.102 0 .315.014.626.024.938v521.724c0 6.537-5.453 11.855-12.156 11.855H130.358c-6.702 0-12.154-5.318-12.154-11.855V186.098c0-6.538 5.452-11.856 12.154-11.856h521.44c15.521 0 28.103-12.582 28.103-28.102s-12.582-28.102-28.102-28.102H130.358c-37.753 0-68.358 30.471-68.358 68.06v706.944c0 37.589 30.605 68.06 68.358 68.06h706.346c37.754 0 68.36-30.471 68.36-68.06V369.48h-.047c-.477-15.103-12.86-27.203-28.08-27.203z" _fill="#2c3e50"/>'
  }
})
